"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseProviderImpl = void 0;
var Future_1 = require("../../../utils/Future");
var Utils_1 = require("../../../utils/Utils");
var FirebaseUtils_1 = require("./../../firebase/FirebaseUtils");
var uuid_1 = require("uuid");
var UserCache_1 = require("./../../UserCache");
var ExerciseProviderImpl = (function () {
    function ExerciseProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " ExerciseProviderImpl#")], args, false));
            }
        };
        this.createExercise = function (exercise, uid) {
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(function (resolve, reject) {
            });
            if (!exercise || !exercise.id || exercise.id === '') {
                return Promise.reject('Incorrect exercise! no exercise id');
            }
            var creator = uid;
            if (!creator || creator.length === 0) {
                var user = (0, UserCache_1.loadUser)();
                if (!user) {
                    return Promise.reject('no user, please sign in');
                }
                creator = user.uid;
            }
            var newExercise = Object.assign(exercise, { creator: creator, updated: Date.now() });
            var path = "/units/".concat(currentUser.unit, "/exercises/").concat(newExercise.creator, "/").concat(newExercise.id);
            _this.log('createExercise# path:', path);
            _this.log('createExercise#, exercise:', newExercise);
            (0, FirebaseUtils_1.setNode)(path, newExercise)
                .then(function () {
                future.resolve();
            })
                .catch(function (err) {
                _this.log('createExercise#, create error!', err);
                future.reject(err);
            });
            return future.promise;
        };
        this.updateExercise = function (exercise) {
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(function (resolve, reject) {
            });
            if (!exercise || !exercise.id || exercise.id === '') {
                return Promise.reject('Incorrect exercise! no exercise id');
            }
            var newExercise = Object.assign({ updated: Date.now() }, exercise);
            var path = "/units/".concat(currentUser.unit, "/exercises/").concat(currentUser.uid, "/").concat(newExercise.id);
            _this.log('updateExercise#, exercise:', newExercise);
            (0, FirebaseUtils_1.updateNode)(path, newExercise)
                .then(function () {
                future.resolve();
            })
                .catch(function (err) {
                _this.log('updateExercise, update exercise/ error!', err);
                future.reject(err);
            });
            return future.promise;
        };
        this.cloneSpecificTeacherExercises = function (srcEmail, unit) {
            if (!srcEmail || !unit) {
                return Promise.reject('invalid srcEmail or unit');
            }
            return (0, FirebaseUtils_1.getNode)("/units/airabbi/exercises/getsulin-gmail-com")
                .then(function (snapshot) {
                var exerciseIds = [];
                snapshot.forEach(function (childSnapshot) {
                    exerciseIds.push(childSnapshot.key);
                });
                return exerciseIds;
            })
                .then(function (exerciseIds) {
                var srcUid = (0, Utils_1.email2UID)(srcEmail);
                var promiseTemps = [];
                return (0, FirebaseUtils_1.getNode)("/units/".concat(unit, "/exercises/").concat(srcUid)).then(function (srcSnapshot) {
                    srcSnapshot.forEach(function (srcChildSnapshot) {
                        var srcExercise = srcChildSnapshot.val();
                        if (srcExercise &&
                            !exerciseIds.find(function (exerciseId) { return exerciseId === srcExercise.id; }) &&
                            srcExercise.title &&
                            srcExercise.title.includes('[SLIME]')) {
                            promiseTemps.push(Promise.resolve((0, FirebaseUtils_1.updateNode)("/units/airabbi/exercises/getsulin-gmail-com/".concat(srcExercise.id), srcExercise)));
                        }
                    });
                    return Promise.all(promiseTemps);
                });
            })
                .then(function () { return Promise.resolve('sync exercise success!'); });
        };
        this.getAllExercises = function () {
            _this.log('getAllExercises# <<<');
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(Future_1.futureFunc);
            var path = "/units/".concat(currentUser.unit, "/exercises/").concat(currentUser.uid);
            _this.log('getAllExercises#, path:', path);
            (0, FirebaseUtils_1.getNode)(path)
                .then(function (snapshot) {
                var exercises = [];
                snapshot.forEach(function (childSnapshot) {
                    var obj = childSnapshot.val();
                    exercises.push(obj);
                });
                _this.log('getAllExercises#, exercises:', exercises);
                future.resolve(exercises);
            })
                .catch(function (err) {
                _this.log("getAllExercises#, error", err);
                future.reject(err);
            });
            return future.promise;
        };
        this.getMyExercisesByPagination = function (codeType, skip, limit, sort, searchString, excludedIds) {
            return Promise.resolve({
                result: [],
                totalCount: 0
            });
        };
        this.getExercise = function (id) {
            if (!id || id === '') {
                return Promise.reject('Incorrect id!');
            }
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(function (resolve, reject) {
            });
            var path = "/units/".concat(currentUser.unit, "/exercises/").concat(currentUser.uid, "/").concat(id);
            _this.log('getExercise#, path:', path);
            (0, FirebaseUtils_1.getNode)(path)
                .then(function (snapshot) {
                var obj = snapshot.val();
                _this.log('getExercise#, exercise:', obj);
                future.resolve(obj);
            })
                .catch(function (err) {
                future.reject(err);
            });
            return future.promise;
        };
        this.log('ExerciseProviderImpl# created!');
    }
    ExerciseProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    ExerciseProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    ExerciseProviderImpl.prototype.getSharedExercises = function (codeType, sharedType, uid) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/exercises");
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/exercises";
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        this.log('getSharedExercises# path:', path);
        if (codeType === 'all') {
            return (0, FirebaseUtils_1.getNode)(path)
                .then(function (snapshot) { return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot)); })
                .catch(function (err) { return Promise.reject(err); });
        }
        return (0, FirebaseUtils_1.queryNode)(path, 'codeType', codeType)
            .then(function (snapshot) {
            _this.log('getSharedExercises# queryNode:', snapshot.val());
            return Promise.resolve((0, FirebaseUtils_1.snapshot2List)(snapshot));
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    ExerciseProviderImpl.prototype.shareExercise = function (exerciseObj, sharedType) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!exerciseObj || !exerciseObj.id || !exerciseObj.creator) {
            return Promise.reject('shareExercise#, incorrect exercise!');
        }
        exerciseObj.sharedType = sharedType;
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/exercises/").concat(exerciseObj.id);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/exercises/".concat(exerciseObj.id);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        return (0, FirebaseUtils_1.setNode)(path, exerciseObj);
    };
    ExerciseProviderImpl.prototype.cloneSharedExercise = function (sharedType, exerciseId) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!exerciseId) {
            return Promise.reject('exerciseId cannot be blank!');
        }
        var path;
        if (sharedType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/exercises/").concat(exerciseId);
        }
        else if (sharedType === 'public') {
            path = "/units/sharedResources/exercises/".concat(exerciseId);
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
        var future = new Future_1.Future(Future_1.futureFunc);
        (0, FirebaseUtils_1.getNode)(path)
            .then(function (snapshot) {
            var exerciseObj = snapshot.val();
            if (!exerciseObj) {
                return future.reject("exerciseObj not found! path: ".concat(path));
            }
            exerciseObj.id = (0, uuid_1.v4)();
            exerciseObj.title = "".concat(exerciseObj.title, " (copy)");
            exerciseObj.creator = currentUser.uid;
            _this.log('cloneSharedExercise# clone exerciseObj:', exerciseObj);
            var tarPath = "/units/".concat(currentUser.unit, "/exercises/").concat(currentUser.uid, "/").concat(exerciseObj.id);
            return (0, FirebaseUtils_1.setNode)(tarPath, exerciseObj)
                .then(function () {
                _this.log('cloneSharedExercise# clone exerciseObj successfully, path:', tarPath);
                _this.log('cloneSharedExercise# clone exerciseObj successfully', exerciseObj);
                future.resolve();
            })
                .catch(function (err) { return future.reject(err); });
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    ExerciseProviderImpl.prototype.searchExercise = function (filter) {
        return Promise.resolve([]);
    };
    ExerciseProviderImpl.prototype.removeExercise = function (id) {
        if (!id || id.trim() === '') {
            return Promise.reject('Incorrect id!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var path = "/units/".concat(currentUser.unit, "/exercises/").concat(currentUser.uid, "/").concat(id);
        this.log('removeExercise#, path:', path);
        return (0, FirebaseUtils_1.removeNode)(path);
    };
    ExerciseProviderImpl.prototype.removeShareExercise = function (id, shareType) {
        if (!id || id.trim() === '') {
            return Promise.reject('Incorrect id!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var path;
        if (shareType === 'unit') {
            path = "/units/".concat(currentUser.unit, "/sharedResources/exercises/").concat(id);
        }
        else if (shareType === 'public') {
            path = "/units/sharedResources/exercises/".concat(id);
        }
        else {
            return Promise.reject('this share type not support!');
        }
        this.log('removeShareExercise#, path:', path);
        return (0, FirebaseUtils_1.getNode)(path).then(function (snapshot) {
            var exerciseObj = snapshot.val();
            if (!exerciseObj) {
                return Promise.reject('shared exercise not exist!');
            }
            if (currentUser.uid === 'kaydemo-airabbi-com') {
                return (0, FirebaseUtils_1.removeNode)(path);
            }
            if (!exerciseObj.creator || exerciseObj.creator !== currentUser.uid) {
                return Promise.reject('owner is wrong!');
            }
            return (0, FirebaseUtils_1.removeNode)(path);
        });
    };
    ExerciseProviderImpl.prototype.stopAllMonitor = function () {
    };
    return ExerciseProviderImpl;
}());
exports.ExerciseProviderImpl = ExerciseProviderImpl;
//# sourceMappingURL=ExerciseProviderImpl.js.map